// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"976aae30","1940":"976aae30","4744":"976aae30","5998":"976aae30","9068":"036d3cab"}[chunkId] + ".chunk.css";
};